import React, { useState, useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import {imageTypes} from '../datas/types';

export function computeResize(width, height, svh) {
    const resonsiveWidth = Math.round((width * svh) / height);
    return [resonsiveWidth, svh];
}

export function ProgressiveImage({datas, className = null, progressSx = null, isResponsive = false, style = null}) {

datas.propTypes = imageTypes;
const [imageSrc, setImageSrc] = useState(null);
const [imageWidth, setImageWidth] = useState(datas.width);
const [imageHeight, setImageHeight] = useState(datas.height);

useEffect(() => {

  if(!datas.src) {
    return;
  }
  const img = new Image();
  img.src = datas.src;
  img.onload = () => {
    setImageSrc(datas.src);
  };

}, [datas, setImageSrc]);

useEffect(() => {
  
  if(!datas.src || !isResponsive) {
    return;
  }

  const handleResize = () => {
      const svh =  window.innerHeight;
      if(datas.width && datas.height) {
        const [width, height] = computeResize(datas.width, datas.height, svh);
        setImageWidth(width);
        setImageHeight(height);
      } 
  }
  handleResize();
  window.addEventListener('resize', handleResize());

  return () => {
    window.removeEventListener('resize', handleResize);
  }

}, [datas, isResponsive, setImageWidth, setImageHeight]);

if(!datas) {
  return <></>
}

const handleError = (error) => {
  console.error(error)
}

return (imageSrc === null ?
    <div className={`opacity-100 flex items-center justify-start`}  style={(imageWidth || imageHeight) && {
      width:imageWidth,
      height:imageHeight,
    }}>
        <Box sx={progressSx}>
          <LinearProgress color="primary"/>
        </Box>
    </div>
    :
    <img 
    onError={() => {handleError()}} 
    src={imageSrc}
    alt={datas.alt ? datas.alt : (datas.figcaption ? datas.figcaption : null)}
    loading="lazy"
    style={
      (isResponsive && (imageWidth || imageHeight)) ? {
        maxWidth:imageWidth + 'px',
        maxHeight:imageHeight + 'px',
        zIndex:1,
      }
      :
      (style ? style : {})
    }
    className={className}
    />
  )
}